import { Transition } from "components/shared/column";
import ScrollPositionContext from "contexts/scrollPosition";
import React, { Component } from "react";
import Body from "./body";

export default class DistributionBidShow extends Component {
    static contextType = ScrollPositionContext;
    componentDidMount() {
        this.context.setPrevItemId(Number(this.props.match.params.id));
    }

    render() {
        return (
            <Transition {...this.props} dir="left">
                <Body {...this.props} />
            </Transition>
        );
    }
}
